"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogin = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
const UserContext_1 = require("../UserContext");
function useLogin() {
    const [jwtToken, setJwtToken] = (0, react_1.useState)();
    const { user, setUser } = (0, react_1.useContext)(UserContext_1.UserContext);
    const { data, isLoading, error, post } = (0, core_ui_1.useApiPost)('users/login');
    (0, react_1.useEffect)(() => {
        if (data) {
            const jwt = data;
            setJwtToken(jwt);
            core_ui_1.api.setAccessToken(jwt.accessToken);
            setUser(jwt.user);
        }
    }, [data, setUser]);
    const doLogin = (0, react_1.useCallback)((email, password) => {
        post({ email, password });
    }, [post]);
    return { jwtToken, user, isLoading, error, doLogin };
}
exports.useLogin = useLogin;
//# sourceMappingURL=useLogin.js.map